import instance from "api";

export const getNotifications = () => {
  return instance(true, null, { throwError: false })
    .get(`/crm/notice/check/`)
    .then(res => {
      return res?.data;
    })
};
export const closeNotice = notice_id => {
  return instance(true)
    .post(`/crm/notice/accept/${notice_id}/`)
    .then(res => {
      return res.data;
    });
};